import { render } from "./App.vue?vue&type=template&id=4ed25d42"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4ed25d42&lang=css"

import exportComponent from "C:\\wamp64\\www\\tafe-raap-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__